export default "__VITE_ASSET__BMkhJm0k__"